import { cn } from "@/lib/utils";
import type { DecisionOption } from "@/types/hld-wizard";

interface OptionCardProps {
  option: DecisionOption;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export function OptionCard({
  option,
  selected,
  onClick,
  disabled,
}: OptionCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "w-full rounded-lg border p-4 text-left transition-all",
        "hover:border-primary/40 hover:bg-accent/50",
        selected && "border-primary bg-primary/5 ring-1 ring-primary/20",
        !selected && "border-border bg-card",
        disabled && "cursor-not-allowed opacity-50",
      )}
    >
      <div className="flex items-start gap-3">
        <div
          className={cn(
            "mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 transition-colors",
            selected
              ? "border-primary bg-primary"
              : "border-muted-foreground/30",
          )}
        >
          {selected && (
            <div className="h-2 w-2 rounded-full bg-primary-foreground" />
          )}
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-semibold">{option.label}</div>
          <div className="mt-1 text-sm text-muted-foreground">
            {option.description}
          </div>
        </div>
      </div>
    </button>
  );
}
